import api from '../../api/index';
import router from '../../router';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';
export default {
  namespaced: true,
  state     : {
    users_requests_table: {
      content: {
        pagination: {
          'rowsPerPage': 10,
          'sortBy'     : 'date',
          'descending' : true,
        },
        headers: [
          {text: 'id', value: 'id'},
          {text: 'Имя / название', value: 'name'},
          {text: 'Тип заявки', value: 'request_type'},
          {text: 'Инициатор', value: 'initiator'},
          {text: 'Дата и время', value: 'date'},
        ],
        body: [

        ],
      },
    },
    org_requests_table: {
      content: {
        pagination: {
          'rowsPerPage': 10,
          'sortBy'     : 'date',
          'descending' : true,
        },
        headers: [
          {text: 'id', value: 'id'},
          {text: 'Имя / название', value: 'name'},
          {text: 'Тип заявки', value: 'request_type'},
          {text: 'Инициатор', value: 'initiator'},
          {text: 'Дата и время', value: 'date'},
        ],
        body: [

        ],
      },
    },
    user_request_forms: [],
    org_request_forms : [],
    showed_filter     : false,
    request_id        : '',
    request_type      : '',
    page              : 1,
    request_pages     : 0,
    requests_amout    : 0,
  },
  getters: {
    page                : ({page}) => page,
    request_pages       : ({request_pages}) => request_pages,
    showed_filter       : ({showed_filter}) => showed_filter,
    users_requests_table: ({users_requests_table}) => users_requests_table,
    org_requests_table  : ({org_requests_table}) => org_requests_table,
    user_request_forms  : ({user_request_forms}) => user_request_forms,
    org_request_forms   : ({org_request_forms}) => org_request_forms,
    request_id          : ({request_id}) => request_id,
    request_type        : ({request_type}) => request_type,
    current_request     : ({request_id, request_type, user_request_forms, org_request_forms=[]}) => {
      let request_forms = request_type == 'Сотрудник' ? user_request_forms : org_request_forms;
      return request_forms.find((item) => item.id == request_id);
    },
  },
  mutations: {
    SET_STATE_REQUEST(state, {key, value}) {
      state[key] = value;
    },
    SET_REQUEST_ID(state, value) {
      state.request_id = value;
    },
    SET_REQUEST_TYPE(state, value) {
      state.request_type = value;
    },
    SET_REQUESTS_PAGINATION(state, value) {
      let {pagination, type} = value;
      let selectedTable;
      if (type=='user') {
        selectedTable = state.users_requests_table.content;
      } else if (type=='org') {
        selectedTable = state.org_requests_table.content;
      }
      selectedTable.pagination = pagination;
    },
    SHOW_NUMBER(state, value) {
      let {selected, type} = value;
      let selectedTable;
      if (type=='user') {
        selectedTable = state.users_requests_table.content;
      } else if (type=='org') {
        selectedTable = state.org_requests_table.content;
      }

      if (selected=='Показывать по 10') {
        selectedTable.pagination.rowsPerPage = 10;
      } else if (selected=='Показывать по 25') {
        selectedTable.pagination.rowsPerPage = 25;
      } else if (selected=='Показывать по 50') {
        selectedTable.pagination.rowsPerPage = 50;
      } else if (selected=='Показывать по 100') {
        selectedTable.pagination.rowsPerPage = 100;
      }
    },
    SET_PAGE(state, value) {
      let {page, type} = value;
      let selectedTable;

      state.page = page;
    },
    SET_PAGES_COUNT(state, value) {
      state.request_pages = value;
    },
    CHANGE_REQUESTS_SORT(state, value) {
      let {sort, type} = value;
      let selectedTable;
      if (type=='user') {
        selectedTable = state.users_requests_table.content;
      } else if (type=='org') {
        selectedTable = state.org_requests_table.content;
      }
      if (selectedTable.pagination.sortBy === sort) {
        selectedTable.pagination.descending = !selectedTable.pagination.descending;
      } else {
        selectedTable.pagination.sortBy = sort;
        selectedTable.pagination.descending = false;
      }
    },
    ADD_REQUEST(state, value) {
      let {request, type, filters} = value;
      if (type=='user') {
        let new_table_user = {
          id          : request.id,
          name        : request.last_name + ' ' + request.name + ' ' + request.patronymic,
          request_type: 'Сотрудник',
          initiator   : request.initiator,
          date        : request.date,
        };
        state.users_requests_table.content.body.push(new_table_user);
        state.requests_amout++;
        request.organization = filters.organizations.find((item)=>item.id==request.organization).text;
        request.role = filters.roles.find((item)=>item.id==request.role).text;
        request.specialization = typeof parseInt(request.specialization) == 'number' ? request.specialization : filters.specializations.find((item)=>item.id==request.specialization).text;

        if (!state.user_request_forms) {
          state.user_request_forms = [request];
        } else {
          state.user_request_forms.push(request);
        }
      } else {
        if (state.org_request_forms !== undefined) {
          state.org_request_forms.push(request);
        }
        state.org_request_forms = [request];
        let logo = request.logo ? request.logo : '';
        let new_table_user = {
          id          : request.id,
          name        : [logo, request.name],
          request_type: 'Организация',
          initiator   : request.initiator,
          date        : request.date,
        };
        state.org_requests_table.content.body.push(new_table_user);
      }
    },
    REMOVE_REQUEST(state, value) {
      let {request, type} = value;
      if (type=='user') {
        let request_form_index = state.user_request_forms.findIndex((item)=>item.id==request);
        let request_index = state.users_requests_table.content.body.findIndex((item)=>item.id==request);
        state.user_request_forms.splice(request_form_index, 1);
        state.users_requests_table.content.body.splice(request_index, 1);
      } else if (type=='org') {
        let request_form_index = state.org_request_forms.findIndex((item)=>item.request_by==request);
        let request_index = state.org_requests_table.content.body.findIndex((item)=>item.request_by==request);
        state.org_request_forms.splice(request_form_index, 1);
        state.org_requests_table.content.body.splice(request_index, 1);
      }
    },
    SET_REQUESTS(state, value) {
      let {table, type} = value;
      if (type=='user') {
        state.user_request_forms = table;

        if (!table) {
          return;
        }

        state.users_requests_table.content.body = table.map((item)=>{
          item = {
            'id'          : item.id,
            'name'        : item.surname + ' ' + item.name,
            'request_type': 'Сотрудник',
            'initiator'   : item.request_by,
            'date'        : item.date,
          };
          return item;
        });
      } else {
        state.org_request_forms = table;
        state.org_requests_table.content.body = table.map((item)=>{
          item = {
            'id'          : item.id,
            'name'        : item.name,
            'request_type': 'Организация',
            'initiator'   : item.request_by,
            'date'        : item.date,
          };
          return item;
        });
      }
    },
  },
  actions: {
    add_new_request({commit, rootGetters}, obj) {
      const initiator = rootGetters['profile/user/user'];
      const filters = rootGetters['users/employees/users_filters'];
      let {request, type} = obj;
      let new_request = {};
      if (type == 'org') {
        new_request = {
          'name'     : request.name,
          'image'    : request.image,
          'region'   : request.region,
          'city'     : request.city,
          'phone'    : request.phone_numbers,
          'email'    : request.email,
          'address'  : request.address,
          'llk'      : request.llk,
          'group'    : request.group,
          'type'     : request.type,
          'about'    : request.about,
          'country'  : request.country,
          'status'   : '',
          'initiator': initiator.family + ' ' + initiator.name + ' ' + initiator.patronymic,
          'date'     : new dayjs().format('DD.MM.YYYY HH:mm:ss'),
        };
      } else {
        new_request = {
          'name'          : request.name,
          'last_name'     : request.last_name,
          'patronymic'    : request.patronymic,
          'email'         : request.email,
          'position'      : request.position,
          'external'      : request.external,
          'department'    : request.department,
          'role'          : request.role,
          'organization'  : request.organization,
          'specialization': request.specialization,
          'initiator'     : initiator.family + ' ' + initiator.name + ' ' + initiator.patronymic,
          'date'          : new dayjs().format('DD.MM.YYYY HH:mm:ss'),
        };
      }
      commit('ADD_REQUEST', {request: new_request, type: type, filters: filters});
    },
    async get_users_requests({state, commit}, obj) {
      let sortBy = state.users_requests_table.content.pagination.sortBy;
      let sortOrder = state.users_requests_table.content.pagination.descending ? 'desc' : 'asc';
      try {
        let requests = await api.user.users_requests(obj.page_size, obj.page_num, sortBy, sortOrder);

        commit('SET_STATE_REQUEST', {key: 'requests_amout', value: requests.data.total || 0});
        commit('SET_REQUESTS', {table: requests.data.content, type: 'user'});
        commit('SET_PAGES_COUNT', requests.data.page_count);
      } catch (err) {
        if (err.message.indexOf('401')!=-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        } {
          console.error(err);
        }
      }
    },
    async get_org_requests({commit}) {
      try {
        let requests = await api.company.company_requests();
        commit('SET_REQUESTS', {table: requests.data.content, type: 'org'});
      } catch (err) {
        if (err.message.indexOf('401')!=-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
      }
    },
  },
};
